import script from "./FragileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FragileCard.vue?vue&type=script&setup=true&lang=js"

import "./FragileCard.vue?vue&type=style&index=0&id=691640a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-691640a8"]])

export default __exports__